import $ from "jquery";
import * as bootbox from "bootbox";
import Ajax from "DMS/Seed/Seed.Ajax";
import Tab from "DMS/Seed/Seed.Tab";
import { empty } from "DMS/Utils/lib";
// uploadController, lib
class Import {
    /**
     * Creation d'un template
     */
    Create() {
        let template = $("#ImportModelName").val();
        let nomtable = $("#ImportModelTable").val();
        if (template === "") {
            bootbox.alert(MSG_EMPTY_CODE);
            return false;
        }
        Ajax.Post({
            url: "_module/ImportFichier/Import.CreateTemplate.php",
            data: "&template=" + template + "&nomtable=" + nomtable,
            json: true,
            async: true,
            success: (xml) => {
                if (xml.retour === 'ok') {
                    Tab.Reload();
                    this.Show(template);
                    $('#ImportModelDetail').css('display', 'none');
                    $('#activeAdvencedMode').prop('checked', true);
                    this.showHide();
                    $('#ImportModelSelected').val(template);
                }
                else {
                    bootbox.alert(xml.retour);
                }
            }
        });
    }
    /**
     * Suppression d'un template
     */
    Delete() {
        let template = $("#ImportModelSelected").val();
        Ajax.Post({
            url: "_module/ImportFichier/Import.DeleteTemplate.php",
            data: "&template=" + template,
            success: () => {
                $("#ImportModelSelected option").filter((i, elem) => $(elem).text() === template).css('display', 'none');
                $("#ImportModelSelected").val('');
                $('#ImportModelDetail').css('display', 'none');
            }
        });
    }
    /**
     * Affichage de la définition d'un template
     * @param ModelName Nom du template
     */
    async Show(ModelName) {
        var table = 'none';
        if ($('#activeAdvencedMode option').prop('checked')) {
            var table = 'block';
        }
        let xml = await Ajax.Post({
            url: "_module/ImportFichier/ModeleDetail.php",
            data: "&template=" + ModelName + "&table=" + table,
            json: true
        });
        $("#ImportModelDetail").html(xml.html);
        var jscript = document.createElement("SCRIPT");
        jscript.text = xml.script;
        Tab.GetFrame().append(jscript);
        $('#ImportModelDetail').css('display', 'block');
        if ($('#activeAdvencedMode').prop('checked')) {
            $('#upload-config').css('display', 'block');
            $('#moreAdvancedConfig').css('display', 'block');
        }
    }
    Init(Template) {
        $(".Seed_Import_Structure").sortable({
            containment: "#upload-config",
            /**
             * Appelé sur le changement d'ordre d'un element de la liste Ou sur la suppression d'un element dans la liste
             * @param  e
             * @param  ui
             */
            update: (e, ui) => {
                var pos = "";
                var cur = 1;
                $(".Seed_Import_Champ").not(".Seed_Import_Disponible").each((i, elem) => {
                    pos += "&" + $(elem).attr("id") + "=" + cur;
                    cur++;
                });
                Ajax.Post({
                    url: "_module/ImportFichier/Import.UpdateStructure.php",
                    data: "template=" + Template + pos,
                });
            },
            /**
             * Appelé lors de la reception (ajout) d'un element dans la liste
             * @param  event
             * @param  ui
             */
            receive: (event, ui) => {
                var pos = "";
                let cur = ui.item.index();
                $(event.target.children).each((i, elem) => {
                    if (empty($(elem).attr("id")))
                        pos += "&" + $(ui.item[0]).attr("id") + "=" + cur;
                    else
                        pos += "&" + $(elem).attr("id") + "=" + cur;
                    cur++;
                });
                Ajax.Post({
                    url: "_module/ImportFichier/Import.UpdateStructure.php",
                    data: "template=" + Template + pos,
                    success: () => {
                        this.Show(Template).then(() => this.backToAnchor());
                    }
                });
            }
        });
        $('.Seed_Import_Disponible').draggable({
            containment: "#upload-config",
            connectToSortable: '.Seed_Import_Structure',
            helper: 'clone',
            delay: 0,
            distance: 0
        });
        $('.Seed_Import_Trash').droppable({
            accept: '.Seed_Import_Champ',
            tolerance: 'pointer',
            over: (event, ui) => {
                $(event.target).css('background-color', 'lightgreen');
            },
            out: (event, ui) => {
                $(event.target).css('background-color', 'white');
            },
            drop: (event, ui) => {
                $(event.target).css('background-color', 'white');
                ui.draggable.remove();
                Ajax.Post({
                    url: "_module/ImportFichier/Import.DeleteField.php",
                    data: "&nomchamp=" + ui.draggable.attr("id") + "&template=" + Template,
                });
            }
        });
    }
    SetKey(Template, Field, Value) {
        Ajax.Post({
            url: "_module/ImportFichier/Import.SetKey.php",
            data: "&nomchamp=" + Field + "&template=" + Template + "&value=" + Value,
            success: () => {
                this.Show(Template).then(() => this.backToAnchor());
            }
        });
    }
    setDelimiter(template, delimiter) {
        if (delimiter !== "") {
            Ajax.Post({
                url: "_module/ImportFichier/Import.SetDelimiter.php",
                data: "&template=" + template + "&delimiter=" + delimiter
            });
        }
        else {
            bootbox.alert(LBL_NO_EMPTY_DATA);
        }
    }
    setDateFormat(template, newDateFormat) {
        if (newDateFormat !== "") {
            Ajax.Post({
                url: "_module/ImportFichier/Import.SetDateFormat.php",
                data: "&template=" + template + "&newDate=" + newDateFormat
            });
        }
        else {
            bootbox.alert(MSG_IMPOSSIBLE_ACTION);
        }
    }
    setSkipHeader(template, newSkipHeaderValue) {
        if (newSkipHeaderValue !== "") {
            Ajax.Post({
                url: "_module/ImportFichier/Import.SetSkipHeader.php",
                data: "&template=" + template + "&skipHeader=" + newSkipHeaderValue
            });
        }
        else {
            bootbox.alert(MSG_IMPOSSIBLE_ACTION);
        }
    }
    setConsistencyTest(template, newAcceptance) {
        if (newAcceptance !== "") {
            Ajax.Post({
                url: "_module/ImportFichier/Import.SetConsistencyTest.php",
                data: "&template=" + template + "&newAcceptance=" + newAcceptance
            });
        }
        else {
            bootbox.alert(MSG_IMPOSSIBLE_ACTION);
        }
    }
    Success(file, serverData) {
        try {
            var progress = new FileProgress(file, this.customSettings.progressTarget);
            if (serverData != "") {
                progress.setStatus("Erreur Import: " + serverData);
            }
            else {
                progress.setComplete();
                progress.setStatus("Import terminé.");
                progress.toggleCancel(false);
            }
        }
        catch (ex) {
            this.debug(ex);
        }
    }
    OfficeToTech() {
        $('#message-synchro').html('');
        Ajax.Post({
            url: "_module/ImportFichier/ImportExport.OfficeToTech.php",
            data: "",
            success: (xml) => {
                eval(xml);
            }
        });
    }
    TechToOffice() {
        $('#message-synchro').html('');
        Ajax.Post({
            url: "_module/ImportFichier/ImportExport.TechToOffice.php",
            data: "",
            success: (xml) => {
                eval(xml);
            }
        });
    }
    /**
     * Retour vers une ancre
     */
    backToAnchor() {
        location.hash = "#upload-config";
        location.hash = 'noHash';
    }
    /**
     * Activer ou désactiver les paramètres avancé
     */
    showHide() {
        if (document.getElementById('activeAdvencedMode').checked) {
            $('#model-creation').show();
            $('#delete-button').show();
            if (document.getElementById('upload-config')) {
                $('#upload-config').show();
            }
            if (document.getElementById('moreAdvancedConfig')) {
                $('#moreAdvancedConfig').show();
            }
        }
        else {
            $('#model-creation').hide();
            $('#delete-button').hide();
            if (document.getElementById('upload-config')) {
                $('#upload-config').hide();
            }
            if (document.getElementById('moreAdvancedConfig')) {
                $('#moreAdvancedConfig').hide();
            }
        }
    }
    /**
     * Active le mode avancé
     */
    getAdvencedParam() {
        $("#hiddenDateFormat").val($("#formatDate").val());
        $("#hiddenDelimiter").val($("#delimiter").val());
        let skipHeaderVal = Tab.GetFrame().find("#skipHeader").attr('checked') === 'checked' ? 1 : 0;
        let paramConsistencyVal = Tab.GetFrame().find("#paramConsistency").attr('checked') === 'checked' ? 1 : 0;
        $("#hiddenSkipHeader").val(skipHeaderVal);
        $("#hiddenConsistencyTest").val(paramConsistencyVal);
    }
}
;
export default new Import();
//# sourceMappingURL=Seed.Import.js.map